import axios from 'axios'
import store from '@/store/store.js'

export default {
  userDetails() {
    return axios
      .get('/api/sessions/user_details', {
        handleErrors: true
      })
      .then(res => {
        return res.data
      })
  },
  fetchUserDownloadNoticeLogs(source) {
    return axios
      .get('/api/user_data_notice_logs?source=' + source, {
        handleErrors: true
      })
      .then(res => {
        return res.data
      })
  },
  addDownloadNoticeLogs(payload) {
    return axios
      .post(
        '/api/user_data_notice_logs',
        {
          source: payload.source,
          details: payload.details
        },
        {
          handleErrors: true
        }
      )
      .then(() => {
        let userDownloadNoticeLogs =
          store.getters['Authentication/userDownloadNoticeLogs']
        userDownloadNoticeLogs[payload.source] = true
      })
  }
}
